const state = {
  fabric: null,
  fit: 'slim',
  lapel: null
};

const basePrice = 8000;

const prices = {
  fabric:{ wool:0, linen:1000, tweed:1500 },
  fit:{ slim:500, regular:0 },
  lapel:{ notch:0, peak:700 }
};

function setFabric(v){ state.fabric=v; update(); }
function setFit(v){ state.fit=v; update(); }
function setLapel(v){ state.lapel=v; update(); }

function update(){
 document.getElementById("base-layer").src =
  `/assets/base-${state.fit}.png`;

 if(state.fabric){
  document.getElementById("fabric-layer").src =
   `/assets/fabric-${state.fabric}.png`;
 }

 if(state.lapel){
  document.getElementById("lapel-layer").src =
   `/assets/lapel-${state.lapel}.png`;
 }

 updatePrice();
}

function updatePrice(){
 let total = basePrice;
 if(state.fabric) total+=prices.fabric[state.fabric];
 if(state.fit) total+=prices.fit[state.fit];
 if(state.lapel) total+=prices.lapel[state.lapel];

 document.getElementById("price").innerText = total;
}
